import React, { useState, useEffect } from 'react';
import Proptypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  tickerTape: Proptypes.shape({
    message: Proptypes.string,
    backgroundColor: Proptypes.string,
  }).isRequired,
  inputRef: Proptypes.object.isRequired,
  onUpdateTickerTape: Proptypes.func.isRequired,
  isStatic: Proptypes.bool,
};
const EditableTickerTape = ({
  tickerTape,
  inputRef,
  onUpdateTickerTape,
  isStatic,
}) => {
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(tickerTape?.message ?? '');

  useEffect(() => {
    setMessage(tickerTape?.message ?? '');
  }, [tickerTape]);

  useEffect(() => {
    if (editing) {
      inputRef?.current?.focus();
    }
  }, [editing]);

  const onUpdate = async () => {
    if (saving) {
      return;
    }

    if (message === tickerTape.message) {
      setEditing(false);
      return;
    }

    setSaving(true);
    await onUpdateTickerTape({
      message,
      color: tickerTape.color ?? '#000000',
      background_color: tickerTape.backgroundColor ?? '#FFFFFF',
    });
    setEditing(false);
    setSaving(false);
  };

  return (
    <div
      role="button"
      tabIndex={0}
      className="ticker-tape-container"
      onClick={() => setEditing(true)}
      style={{ backgroundColor: tickerTape?.backgroundColor ?? '#FFFFFF' }}
    >
      {editing || isStatic ? (
        <input
          ref={inputRef}
          value={message}
          disabled={saving}
          placeholder="Type something here"
          style={{ color: tickerTape?.color ?? '#000000' }}
          onKeyDown={event => {
            if (event.key === 'Enter') {
              onUpdate();
            }
          }}
          onChange={({ target }) => {
            setMessage(target.value);
          }}
          onBlur={onUpdate}
        />
      ) : (
        <p
          style={{ color: tickerTape?.color ?? '#000000' }}
          className={classNames({
            text: true,
            'is-static': isStatic,
          })}
        >
          {tickerTape.message ?? 'Type your message here!'}
        </p>
      )}
    </div>
  );
};

EditableTickerTape.propTypes = propTypes;

export default EditableTickerTape;
